/*
  eslint-disable
  no-restricted-syntax, guard-for-in, prefer-const, no-unused-expressions,
*/
export function propsToClasses(props, styles) {
  var key;
  var val;
  var classes = '';
  for (var prop in props) {
    val = props[prop];
    if (val) {
      if (typeof val === 'string') {
        key = "".concat(prop, "-").concat(val);
      } else {
        key = prop;
      }
      if (key in styles) {
        classes && (classes += ' ');
        classes += styles[key];
      }
    }
  }
  return classes;
}